import { MDBBtn, MDBDatatable, MDBIcon, MDBInput, MDBSelect } from "mdb-react-ui-kit";
import { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { getAccInfo, getMisc, UpdateAccPinCID } from "../../../apiclients/streamsapi_bridge";
import SaveChanges from "../saveCancel";
import TopSuccess from "../../header/TopSuccess";
import TopMessage from "../../header/TopMessage";
import { Tooltip } from "react-tooltip";
import PopupLoaderNew from "../../../views/popups/PopupLoaderNew";
import AddToUsers from "../../../views/popups/misc/AddToUsers";
import { useTranslation } from "react-i18next";
import PopupLoader from "../../../views/popups/PopupLoader";
import AddToGroup from "../../../views/popups/users/AddToGroup";
import DeleteGroup from "../../../views/popups/users/DeleteGroup";
import RemoveToUser from "../../../views/popups/misc/RemoveToUser";
import { formattedNumber } from "../../../views/popups/phonenumbers/AddRemoveNumbers";
import { customSearch, useAutoFocusSearchAfterLoads } from "../../CustomSearchUtil/CustomSearch";
import UIConstant from "../../../apiclients/UIConstant";



const AccPhoneNumbers = ({ register, setValue, clearErrors, errors, watch, setError, existingUsers, setExistingUsers, existingGroups, setExistingGroups, existingMembers, setExistingMembers }) => {

    const { t } = useTranslation();

    const [isloading, setIsloading] = useState(false);
    const [internalError, setInternalError] = useState(false);
    const [callerIdList, setCallerIdList] = useState([]);
    const [billingPhNumList, setBillingPhNumList] = useState([]);
    const [allowCidList, setAllowCidList] = useState({});
    const [successMessage, setSuccessMessage] = useState("");
    const [addUsers, setAddUsers] = useState(false);
    const [sourceUsers, setSourceUsers] = useState([]);
    const [updateUsers, setUpdateUsers] = useState([]);
    const [isAddedUsers, setIsAddedUsers] = useState(false);
    const [isdeleteUser, setIsDeleteUser] = useState(false);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [message, setMessage] = useState("");
    const [usersUpdated, setUsersUpdated] = useState(false);
    const [selUserAndPhnum, setSelUserAndPhnum] = useState([]);
    const addUserRef = useRef(null);
    const [addGroup, setAddGroup] = useState(false);
    const toggleGroup = () => setAddGroup(!addGroup);
    const [selectedGroups, setSelectedGroups] = useState([]);
    const [updateGroups, setUpdateGroups] = useState([]);
    const [updateGroupsExecuted, setUpdateGroupsExecuted] = useState(false);
    const [sourceGroups, setSourceGroups] = useState([]);
    const [isdeleteGroup, setIsDeleteGroup] = useState(false);
    const dGrouptogglePopup = () => setIsDeleteGroup(!isdeleteGroup);
    const [deleteGroupFlag, setdeleteGroupFlag] = useState(false);
    const [isdelete, setIsDelete] = useState(false);
    const dUsertogglePopup = () => setIsDelete(!isdelete);
    const [searchValue, setSearchValue] = useState("");
    const [filteredRows, setFilteredRows] = useState([]);
    const [rowDetails, setRowDetails] = useState([]);
     const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);

 useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded,searchRef)




    function handleClick() {
        addUserRef.current.click();
    }






    useEffect(() => {
        if (successMessage) {
            setTimeout(() => {
                setSuccessMessage(""); // Clear the success message in the parent component
            }, 5000);
        }
    }, [successMessage]);


    async function fetchAccMiscData() {
        console.log(sessionStorage.getItem("admin_session"));
        const response = await getMisc(
            JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            { misc: ["accpin_cid"] }
        );
        if (!response.json) {
            const message = `An error has occured: ${response.statusText}`;
            return;
        }
        const tdata = await response.json();
        console.log(`billing misc data is :::::: ${JSON.stringify(tdata)}`)
        if (!tdata) {
            window.alert(`info with id  not found`);
        };
        console.log("caller id lsit ::::::::::::::; " + JSON.stringify(tdata?.misc?.accpin_cid?.allow_shared_callerid));
        const arrangeCIDList = (tdata?.misc?.accpin_cid?.callerIds ?? []).map((item) => ({ text: (formattedNumber(item.phnum) + " " + item.addlinfo), value: item.phnum }));
        const arrangeBillingList = (tdata?.misc?.accpin_cid?.billingNumList ?? []).map((item) => ({ text: formattedNumber(item), value: item }));
        const arrangeAllowCidList = (tdata?.misc?.accpin_cid?.allow_shared_callerid !== undefined && Object.keys(tdata?.misc?.accpin_cid?.allow_shared_callerid).length > 0) ?
            (Object.entries(tdata?.misc?.accpin_cid?.allow_shared_callerid ?? {}).map(([key, value]) => ({
                text: value,
                value: key,
            }))) : [];

        setCallerIdList(arrangeCIDList);
        setBillingPhNumList(arrangeBillingList);
        setAllowCidList(tdata?.misc?.accpin_cid?.allow_shared_callerid ?? {});
        setSourceUsers(tdata?.misc?.accpin_cid?.agent_list ?? []);
        setSourceGroups(tdata?.misc?.accpin_cid?.group_list ?? []);
    }

    useEffect(() => {
        fetchAccMiscData();
    }, []);

    const closeTogglePopup = () => setAddUsers(!addUsers);

    useEffect(() => {
        if (updateUsers.length > 0 && isAddedUsers) {
            updateTheUser("add_users");
            setIsAddedUsers(false);
        }
    }, [updateUsers, isAddedUsers]);

    useEffect(() => {
        if (updateUsers.length > 0 && isdeleteUser) {
            updateTheUser("remove_user_groups");
            setIsDeleteUser(false);
        }
    }, [updateUsers, isdeleteUser]);

    async function updateTheUser(fieldName) {
        const agentids = new Set(updateUsers?.map(item => item.id));
        let update = {}

        let saverep;
        update = {
            reqid: 64,
            siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            global_settings: {
                global_acc_settings: {
                    acc_cid: {
                        [fieldName]: Array.from(agentids),
                        allow_shared_callerid: 1
                    }
                }
            }

        };

        console.log(JSON.stringify(update));
        saverep = await UpdateAccPinCID(update);
        console.log(saverep);
        let saverepeMsg = await saverep.json();
        const usernames = new Set(updateUsers?.map(item => item.name));
        const users = Array.from(usernames).join(', ');
        if (saverepeMsg.status && saverepeMsg.status == "success") {
            if (fieldName === "add_users") {
                const updatedUsers = [...existingUsers, ...updateUsers]
                setExistingUsers(updatedUsers);
                setSelectedUsers(updatedUsers);
                setExistingMembers([...existingMembers, ...updateUsers]);

                setSuccessMessage(`User(s) ${users} added successfully.`);
                setUsersUpdated(true);
            } else {
                const filterExtension = new Set(updateUsers?.map(item => item.extension));
                const filterUsers = selectedUsers.filter((item) => !filterExtension.has(item.extension));
                const filterGroupUsers = existingUsers.filter((item) => !filterExtension.has(item.extension));
                setExistingUsers(filterGroupUsers);
                setSelectedUsers(filterUsers);
                setUsersUpdated(true);
                setExistingMembers([...filterGroupUsers, ...existingGroups]);
                setSuccessMessage(
                    `User(s) ${users} removed successfully.`
                );
            }
            clearErrors("global_settings.global_acc_settings.acc_cid.allow_shared_callerid")
        }
    }

    function handleDeleteMember(event, memObj) {
        event.preventDefault();
        event.stopPropagation();
        setUpdateUsers([memObj]);
        setUpdateGroups([memObj]);
        if (memObj.id) {
            dUsertogglePopup();
        } else {
            dGrouptogglePopup();

        }
    }
useEffect(()=>{
    let proccessdRows = [];
    existingMembers?.map((member, index) => {
        proccessdRows.push({
            member: member,
            name: member.name ?? member.title,
            extension: member.extension ?? member.extensions,
            type: member.type ?? "--",
            location: member.loc_name ?? member.location_name,
            remove: (
                <>
                    <div className="d-flex">
                        <div
                            className="custom-hover-bg ms-3 p-1 cursor-pointer deleteToolTip"
                            onClick={(e) => handleDeleteMember(e, member)}

                        >
                            <MDBIcon className="fs-5" far icon="trash-alt" color="primary" />
                        </div>
                    </div>
                </>
            ),
        });
    });
    setFilteredRows(proccessdRows)
    setRowDetails(proccessdRows)
    setDataLoaded(true)
    },[existingMembers])


    const actionData = {
        columns: [
            { label: 'Name', field: 'name' },
            { label: 'Extension', field: 'extension' },
            { label: 'Type', field: 'type' },
            { label: 'Location', field: 'location' },
            { label: 'Remove', field: 'remove', sort: false },
        ],
        rows: rowDetails
    };

    const handleManualSearch = (searchValue) => {
        setSearchValue(searchValue);
        const filtered = customSearch(rowDetails, searchValue, UIConstant.ACC_PHONE_NUMBERS);

        setFilteredRows(filtered);
    };

    useEffect(() => {
        if (updateGroups.length > 0 && updateGroupsExecuted) {
            addGroups("add_groups");
            setUpdateGroupsExecuted(false);
        }
    }, [updateGroups, updateGroupsExecuted]);

    useEffect(() => {
        if (updateGroups.length > 0 && deleteGroupFlag) {
            addGroups("remove_user_groups");
            setdeleteGroupFlag(false);
        }
    }, [updateGroups, deleteGroupFlag]);


    async function addGroups(fieldName) {
        const addcodeList = new Set(updateGroups?.map((item) => item.code?.toString()));
        const addtitleList = new Set(updateGroups?.map((item) => item.title));
        let update = {
            reqid: 64,
            siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            global_settings: {
                global_acc_settings: {
                    acc_cid: {
                        [fieldName]: Array.from(addcodeList),
                    }
                }
            }
        };

        console.log(JSON.stringify(update));
        let saverep = await UpdateAccPinCID(update);
        console.log(saverep);
        let saverepeMsg = await saverep.json();
        if (saverepeMsg.status && saverepeMsg.status == "success") {
            if (fieldName === "add_groups") {
                const modifygrp = [...existingGroups, ...updateGroups];
                setExistingGroups(modifygrp);
                setExistingMembers([...existingMembers, ...updateGroups]);
                setSuccessMessage(
                    `Group(s) ${Array.from(addtitleList)} added successfully.`
                );
            } else {
                const updategroup = existingGroups.filter((item1) =>
                    updateGroups.some((item2) => item2.code !== item1.code)
                );
                setExistingGroups(updategroup);
                setExistingMembers([...existingUsers, ...updategroup]);
                setSuccessMessage(
                    `Group(s) ${Array.from(addtitleList)} removed successfully.`
                );
            }
            clearErrors("global_settings.global_acc_settings.acc_cid.allow_shared_callerid")
        }
        else {
            if (saverepeMsg.message?.errors) {
                saverepeMsg.message.errors.forEach((err) => {

                    console.log(`err object in addGroups is :::::: ${JSON.stringify(err)}`);
                    setError(err.param_name, {
                        type: "server",
                        message: err.message,
                    });
                    const fieldElement = document.querySelector(
                        `input[name="${err.param_name}"]`
                    );
                    if (fieldElement) {
                        fieldElement.focus();

                    }
                });
            }

        }
    }




    return (
        <>
            <div className="w-100">
                {/* <div className="add-numbermain" >
                    <label>Account PIN</label>
                    <div className="w-30 me-4" >
                        <MDBInput
                            className="w-100"
                            type="number"
                            {...register('pin', {
                                required: "PIN is required",
                                setValueAs: (value) => value === "" ? null : parseInt(value, 10)
                            })}

                        />
                        {errors.pin && (
                            <p className="text-danger">{errors.pin.message}</p>
                        )}

                    </div>
                </div> */}
                <div className="add-numbermain" >
                    <label>Default Caller ID</label>
                    <div className="w-30 me-4" >
                        <div
                            className="w-100"
                            title={
                                [
                                    { text: "Select Default Caller ID", value: "-1" },
                                    ...callerIdList
                                ].find(
                                    item =>
                                        item.value === watch("global_settings.global_acc_settings.acc_cid.default_cid")
                                )?.text || "Select Default Caller ID"
                            }
                        >
                            <MDBSelect className="w-100"
                                data={[{ text: "Select Default Caller ID", value: "-1" }, ...callerIdList]}
                                value={watch("global_settings.global_acc_settings.acc_cid.default_cid")}
                                onChange={(e) => {
                                    if (e && e.value) {
                                        clearErrors("global_settings.global_acc_settings.acc_cid.default_cid");
                                        setValue("global_settings.global_acc_settings.acc_cid.default_cid", e.value, { shouldDirty: true });
                                    }
                                }}
                            />
                        </div>
                        {errors?.global_settings?.global_acc_settings?.acc_cid?.default_cid && (
                            <p className="text-danger">{errors?.global_settings.global_acc_settings?.acc_cid?.default_cid.message}</p>
                        )}

                    </div>
                </div>

                <div className="add-numbermain" >
                    <label>Default Caller ID Name</label>
                    <div className="w-30 me-4" >
                        <MDBInput maxLength={15} className="w-100" placeholder="Caller ID Name"
                            {...register('global_settings.global_acc_settings.acc_cid.default_cid_name', {
                                required: "Default Caller ID Name is required"
                            })}
                        />
                        {errors?.global_settings?.global_acc_settings?.acc_cid?.default_cid_name && (
                            <p className="text-danger">{errors?.global_settings.global_acc_settings?.acc_cid?.default_cid_name.message}</p>
                        )}
                    </div>
                </div>


                <div className="add-numbermain" >
                    <label>Billing Phone Number</label>
                    <div className="w-30 me-4" >
                        <MDBSelect className="w-100"
                            data={[{ text: "Select Billing Phone Number", value: "-1" }, ...billingPhNumList]}
                            value={watch("global_settings.global_acc_settings.acc_cid.billing_phnum")}
                            onChange={(e) => {
                                if (e && e.value) {
                                    clearErrors("global_settings.global_acc_settings.acc_cid.billing_phnum");
                                    setValue("global_settings.global_acc_settings.acc_cid.billing_phnum", e.value, { shouldDirty: true });
                                }
                            }}
                        />
                        {errors?.global_settings?.global_acc_settings?.acc_cid?.billing_phnum && (
                            <p className="text-danger">{errors?.global_settings.global_acc_settings?.acc_cid.billing_phnum.message}</p>
                        )}
                    </div>
                </div>
                <div className="add-numbermain" >
                    <label>Allow Shared Caller ID</label>

                    <div className="w-30 me-4 position-relative" >
                        <select
                            className="form-control form-select selectname"
                            name="allow_shared_callerid"

                            value={watch("global_settings.global_acc_settings.acc_cid.allow_shared_callerid")}

                            onChange={(e) => {
                                clearErrors("global_settings.global_acc_settings.acc_cid.allow_shared_callerid")
                                setValue("global_settings.global_acc_settings.acc_cid.allow_shared_callerid", parseInt(e.target.value), { shouldDirty: true })
                            }}

                        >

                            {Object.entries(allowCidList).map(([key, value]) => (
                                <option key={value} value={parseInt(key)}>
                                    {value}
                                </option>
                            ))}

                        </select>
                        <div className="infoToolTip  ms-2 AllowSharedCaller">
                            <MDBIcon fas icon="info-circle" />
                        </div>


                        {errors?.global_settings?.global_acc_settings?.acc_cid?.allow_shared_callerid && (
                            <p className="text-danger">{errors?.global_settings.global_acc_settings?.acc_cid.allow_shared_callerid.message}</p>
                        )}
                    </div>

                </  div>
                {(parseInt(watch("global_settings.global_acc_settings.acc_cid.allow_shared_callerid")) === 1) && (

                    <div className="mt-3 position-relative">
                        <div className="actionbar">
                            <MDBBtn onClick={closeTogglePopup} ><MDBIcon fas icon="add" /> Add Users</MDBBtn>

                            <MDBBtn className="ms-2" onClick={(e) => {
                                e.preventDefault();
                                toggleGroup();
                            }}>  <MDBIcon fas icon="add" /> Add Groups</MDBBtn>

                        </div>
                        <div className='mb-2 mt-0 position-relative w-auto'>
                            <MDBInput
                                label="Search"
                                ref={searchRef}
                                value={searchValue}
                                onChange={(e) => handleManualSearch(e.target.value)}
                            />
                            <MDBIcon fas icon="search" className='MDBDatatable-Search' />
                        </div>
                        <MDBDatatable key={searchValue} hover entries={10000} data={{...actionData,rows:filteredRows}} pagination={false}
                            // search
                        />


                    </div>
                )

                }
            </div>



            {addUsers && (
                <PopupLoaderNew
                    title={t("addusers")}
                    content={<AddToUsers
                        onClose={closeTogglePopup}
                        selectedUsers={existingUsers}
                        setUpdateUsers={setUpdateUsers}
                        setIsAddedUsers={setIsAddedUsers}
                        sourceUsers={sourceUsers}
                        allowDuplicate={false}
                        ref={addUserRef}
                        setIsloading={setIsloading}
                        clearErrors={clearErrors}

                    />}
                    onShow={setAddUsers}
                    onClose={closeTogglePopup}
                    onSave={handleClick}
                    isloading={isloading}
                    flag={2}
                />
            )
            }

            {
                isdelete && (
                    <PopupLoaderNew
                        title={"Remove User"}
                        content={
                            <RemoveToUser
                                setIsDeleteUser={setIsDeleteUser}
                                onClose={dUsertogglePopup}
                                ref={addUserRef}
                                setIsloading={setIsloading}

                            />
                        }
                        onShow={setIsDelete}
                        onClose={dUsertogglePopup}
                        onSave={handleClick}
                        isloading={isloading}
                        flag={4}
                    />
                )
            }

            {addGroup && (
                <PopupLoader
                    title={t("AddtoGroup")}
                    content={
                        <AddToGroup
                            isglobal={true}
                            selectedGroups={existingGroups}
                            setUpdateGroups={setUpdateGroups}
                            setUpdateGroupsExecuted={setUpdateGroupsExecuted}
                            sourceGroups={sourceGroups}
                            onClose={toggleGroup}
                        />
                    }
                    onShow={setAddGroup}
                    onClose={toggleGroup}
                />
            )}

            {isdeleteGroup && (
                <PopupLoader
                    title={"Remove Group"}
                    content={
                        <DeleteGroup
                            onClose={dGrouptogglePopup}
                            setdeleteGroupFlag={setdeleteGroupFlag}
                        />
                    }
                    onShow={setIsDeleteGroup}
                    onClose={dGrouptogglePopup}
                />
            )}


            {successMessage && (
                <>
                    <TopSuccess>
                        <TopMessage successMessage={successMessage} />
                    </TopSuccess>
                </>
            )}

            <Tooltip anchorSelect=".infoToolTip" place="right" className="exampleTooltip">
                Selecting Groups allows users to set assigned DIDs <br /> of users in the selected group as Caller ID.
            </Tooltip>

            <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
                Remove
            </Tooltip>
        </>
    );

}


export default AccPhoneNumbers;
